import { createSlice } from "@reduxjs/toolkit";
// import { getShoppingListData } from "./actions";

const initialState = {
  isLoading: false,
  isError: false,
  shoppingListAemData: {},
};

const GetShoppingListDataSlice = createSlice({
  name: "shoppinglist",
  initialState,
  reducers: {
    setShoppingListPageData: (state, action) => {
      state.shoppingListAemData = action?.payload?.data?.shoppingListModelList;

    }
  },
  extraReducers: (builder) => {
    // builder.addCase(getShoppingListData?.pending, (state) => {
    //   state.isLoading = true;
    //   state.isError = false;
    // });
    // builder.addCase(getShoppingListData?.fulfilled, (state, action) => {
    //   state.isLoading = false;
    //   state.isError = false;
    //   state.shoppingListAemData = action?.payload?.["data"]?.["shoppingListModelList"];
    // });
    // builder.addCase(getShoppingListData.rejected, (state) => {
    //   state.isLoading = false;
    //   state.isError = true;
    // });
  },
});

export const {
  setShoppingListPageData
} = GetShoppingListDataSlice.actions;


export const getShoppingListDataSlice = GetShoppingListDataSlice.reducer;
